import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=552cf104&scoped=true"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552cf104",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('552cf104')) {
      api.createRecord('552cf104', component.options)
    } else {
      api.reload('552cf104', component.options)
    }
    module.hot.accept("./ContactForm.vue?vue&type=template&id=552cf104&scoped=true", function () {
      api.rerender('552cf104', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/forms/ContactForm.vue"
export default component.exports